var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckShieldinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 30,
  fill: "none",
  viewBox: "0 0 26 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.522 0H2.477A1.875 1.875 0 0 0 .613 1.875v7.829a22.82 22.82 0 0 0 12.094 20.222.62.62 0 0 0 .586.002A22.83 22.83 0 0 0 25.386 9.703V1.875A1.875 1.875 0 0 0 23.522 0m-3.147 9.931L11.5 18.306a1.25 1.25 0 0 1-1.75-.03l-2.967-2.995a1.251 1.251 0 1 1 1.777-1.758l2.102 2.125 7.994-7.534a1.252 1.252 0 0 1 1.719 1.817"
})));
export default SvgCheckShieldinline;